var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInverter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.668 20.932h4.342c.734 0 1.331-.577 1.331-1.286V13.11c0-.259-.217-.469-.485-.469-.269 0-.486.21-.486.469v6.536c0 .188-.165.348-.36.348H1.356c-.196 0-.36-.16-.36-.348V1.364c0-.189.164-.348.36-.348h9.654c.195 0 .36.16.36.348v15.537c0 .259.217.469.486.469.268 0 .485-.21.485-.47V1.365c0-.709-.597-1.286-1.331-1.286H1.356C.62.078.024.655.024 1.364v18.282c0 .709.597 1.286 1.332 1.286H6.668z",
    transform: "translate(-110 -576) translate(98 222) translate(0 342) translate(12 12) rotate(-90 9.5 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.418 3.047c-.13 0-.235.21-.235.469v13.978c0 .258.105.468.235.468h3.529c.13 0 .236-.21.236-.468V3.516c0-.259-.106-.469-.236-.469H4.418zm2.765 13.938h-2v-13h2v13z",
    transform: "translate(-110 -576) translate(98 222) translate(0 342) translate(12 12) rotate(-90 9.5 8)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInverter);
export default __webpack_public_path__ + "static/media/ic-inverter.704f6baf6a3e748620b993da5d4aad9d.svg";
export { ForwardRef as ReactComponent };